import React from 'react'

const ArrowRightIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0297 3.04712C14.7674 3.12824 14.5298 3.2741 14.3387 3.47125C14.1147 3.6923 13.9641 3.97688 13.9073 4.28642C13.8504 4.59596 13.8902 4.91548 14.021 5.20169C14.0904 5.36055 14.5608 5.85254 16.4085 7.70174C17.185 8.47017 17.9521 9.24805 18.7096 10.0352C18.7096 10.0522 14.7444 10.0707 9.89849 10.0769L1.0874 10.0877L0.852975 10.2018C0.486598 10.3892 0.207341 10.7116 0.0741197 11.1009C-0.0430941 11.4896 -0.0215021 11.8783 0.140438 12.2376C0.286955 12.5646 0.635512 12.8992 0.971731 13.035L1.21079 13.1306L9.96944 13.1414L18.7281 13.1522L16.4224 15.4656C13.8545 18.0412 13.9516 17.9225 13.9084 18.5379C13.8689 18.8876 13.965 19.2392 14.1768 19.5203C14.5315 19.9907 14.9834 20.2081 15.5433 20.1758C16.1602 20.1403 15.9088 20.3608 20.0668 16.1843C23.085 13.1537 23.8084 12.4057 23.8917 12.233C23.9811 12.0479 23.995 11.9646 23.995 11.5883C23.995 10.8388 24.3035 11.2012 20.076 6.97378C16.5951 3.49284 16.3699 3.27692 16.1093 3.15508C15.7808 3.00239 15.3057 2.95458 15.0297 3.04712Z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default ArrowRightIcon
